import {
  createSystem,
  defaultConfig,
  defineConfig,
  type SystemConfig,
  type SystemContext,
} from '@chakra-ui/react';

import { baseThemeConfig } from '../theme';

/**
 * Create a Chakra system that inherits the Metropolis base theme, then applies overrides.
 */
export function createTheme(...overrides: SystemConfig[]): SystemContext {
  return createSystem(defaultConfig, baseThemeConfig, ...overrides);
}

/** Helper to type override configs consistently with the base theme. */
export function defineThemeOverride(config: SystemConfig): SystemConfig {
  return defineConfig(config);
}
